import type { CronScheduleConfig } from './types.js';
import type { CronValidation } from './useCronValidation.js';

export type BuildCronScheduleConfigResult =
  | { config: CronScheduleConfig }
  | { error: string }
  | { blocked: true };

/**
 * Turns a cron pattern/timezone plus its current validation state into one of three
 * outcomes: a submittable `config`, an `error` message the caller should display, or
 * `blocked` (submission must stop, but the inline `cronValidation.error` ErrorBanner
 * under the cron fields already explains why — don't render a second one).
 */
export function buildCronScheduleConfig(
  pattern: string,
  timezone: string,
  validation: CronValidation
): BuildCronScheduleConfigResult {
  if (!pattern) {
    return { error: 'Cron pattern is required' };
  }
  if (!validation.settled || validation.preview.length === 0) {
    return validation.settled && validation.error
      ? { blocked: true }
      : { error: 'Please enter a valid cron pattern' };
  }
  return { config: { pattern, timezone } };
}
